var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("" + (_vm.textLength > _vm.maxText && 'tw-text-red-500'))},[_vm._v("\n  "+_vm._s(("(" + _vm.textLength + "/" + _vm.maxText + ")"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }